import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toggle } from '@keen.io/ui-core';
import Label from '../../../Label';
import Row from '../../../Row';

var GridSettings = function GridSettings(_ref) {
  var verticalGrid = _ref.verticalGrid,
      horizontalGrid = _ref.horizontalGrid,
      _onChange = _ref.onChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement(React.Fragment, null, React.createElement(Row, {
    "data-testid": "vertical-grid"
  }, React.createElement(Label, null, t('widget_customization_grid_settings.vertical_grid')), React.createElement(Toggle, {
    isOn: verticalGrid,
    onChange: function onChange(gridEnabled) {
      return _onChange({
        verticalGrid: gridEnabled
      });
    }
  })), React.createElement(Row, {
    "data-testid": "horizontal-grid"
  }, React.createElement(Label, null, t('widget_customization_grid_settings.horizontal_grid')), React.createElement(Toggle, {
    isOn: horizontalGrid,
    onChange: function onChange(gridEnabled) {
      return _onChange({
        horizontalGrid: gridEnabled
      });
    }
  })));
};

export default GridSettings;